const COLORS = ['#558651','#FFC66D','#9876AA','#6897BB'] 

export default COLORS